export default __webpack_public_path__ + "static/media/SindhuResume.27bb7204.pdf";